import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { LinkButton } from '@atlaskit/button/new';
import SettingsIcon from '@atlaskit/icon/core/settings';

import { COMPANY_HUB_SETTINGS } from '@confluence/named-routes';

type HubSettingsEntryButtonProps = {
	loading?: boolean;
};

const i18n = defineMessages({
	buttonText: {
		id: 'company-hub.hub-settings.entry-button',
		defaultMessage: 'Hub Settings',
		description: 'Text for Hub settings entry point button',
	},
});

export const HubSettingsEntryButton = ({ loading }: HubSettingsEntryButtonProps) => (
	<LinkButton
		appearance="subtle"
		iconBefore={SettingsIcon}
		href={COMPANY_HUB_SETTINGS.toUrl()}
		isDisabled={loading}
	>
		<FormattedMessage {...i18n.buttonText} />
	</LinkButton>
);

export const HubSettingsEntryButtonPlaceholder = () => <HubSettingsEntryButton loading />;
